import { SheetTab } from "@/features/order-sheets/sheet.type";
import {
  calcIdentityUrlPrefix,
  parseYWRUrl,
  SWRObjectKey,
} from "@/features/ui/helpers/fetcher-helpers";
import { IdentityParameter } from "@/features/types";
import { AxiosRequestConfig } from "axios";
import { singularizeCompanyType } from "@/features/ui/helpers/identity-helpers";
import useSWR, { SWRConfiguration } from "swr";
import useListAllSheetTabsV2Fetcher from "@/features/line-sheet-sets/hooks/use-list-all-sheet-tabs-fetcher-v2";

export interface ListAllSheetTabsV2Request {
  lineSheetSetId: number;
}

export interface ListAllSheetTabsV2Response {
  sheetTabs: SheetTab[];
  _orderSheetSetId: number;
}

export interface ListAllSheetTabsV2PathParameter extends IdentityParameter {
  orderSheetSetId: number;
}

export function getListAllSheetTabsV2Key(
  parameter?: ListAllSheetTabsV2PathParameter,
  request?: ListAllSheetTabsV2Request
): SWRObjectKey<ListAllSheetTabsV2Request> | null {
  if (parameter && request) {
    const { orderSheetSetId } = parameter;
    let url = calcIdentityUrlPrefix(parameter);
    url += `/sheet-sets/${orderSheetSetId}/sheet-tabs`;
    return {
      url,
      params: request,
    };
  }
  return null;
}

export function parseListAllSheetTabsV2Key(
  key: AxiosRequestConfig<ListAllSheetTabsV2Request>
): {
  parameter: ListAllSheetTabsV2PathParameter;
  request: ListAllSheetTabsV2Request;
} {
  const { url, params } = key;
  const obj = parseYWRUrl(
    "/:companyType/:companyId/sheet-sets/:orderSheetSetId/sheet-tabs",
    url!!
  );

  const parameter: ListAllSheetTabsV2PathParameter = {
    by: singularizeCompanyType(obj["companyType"]),
    companyId: parseInt(obj["companyId"]),
    orderSheetSetId: parseInt(obj["orderSheetSetId"]),
  };

  return {
    parameter,
    request: key.params!!,
  };
}

export default function useListAllSheetTabsV2(
  parameter?: ListAllSheetTabsV2PathParameter,
  request?: ListAllSheetTabsV2Request,
  config: SWRConfiguration = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  }
) {
  const fetcher = useListAllSheetTabsV2Fetcher();

  return useSWR(getListAllSheetTabsV2Key(parameter, request), fetcher, config);
}
